<wep-page-tpl-login-default>
    <wep-page-tpl-login-default-heading>
        <span>404 — Page Not Found</span>
    </wep-page-tpl-login-default-heading>
    <wep-page-tpl-login-default-content>
        <div class="message">
            <p>
                Looks like you’re lost!<br/>Take me back to the <a (click)="goToHome()">home page</a>.
            </p>
        </div>
    </wep-page-tpl-login-default-content>
</wep-page-tpl-login-default>
